if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          // this.checkEngraving().then(() => {});

          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    /**
     * Engraving adjustments
     */

    // Check Engraving items
    async checkEngraving() {
      let form = JSON.parse(serializeForm(this.form));
      // Check if the cart already has the same item
      // let cart = await this.checkCart();
    }

    // async checkCart() {
    //   let engravingQuantity = 0;
    //   let cartHasEngraving = false;
    //   let itemHasEngraving = false;
    //   fetch('/cart.js', { })
    //       .then(response => response.json())
    //       .then(data => {
    //           if (data.items.length > 0) {  
    //             data.items.forEach(element => {

    //               // if (('Engraving' in element.properties && element.properties['Engraving'] != '') || 
    //               //     ('Engraving image' in element.properties && element.properties['Engraving image'] != '')) {
    //               //   engravingQuantity += element.quantity;
    //               //   itemHasEngraving = true;
    //               // }

    //               // Check 
    //               // if (element.id == EngravingItem.getItemId()) {
    //                 // @TODO: if is the Engraving item variant then allow to add custom text
    //                 // cartHasEngraving = true;
    //               // }
    //             });
    //             // this.addEngravingToCart(cartHasEngraving, engravingQuantity);
    //           }
    //           Promise.resolve(data);
    //       });
    // }

    // addEngravingToCart(hasEngraving, qty) {
    //   // Add engraving to cart
    //   // Update engraving item quantity in case already exists
    //   if (!hasEngraving) {
    //     // Add engraving to cart
    //     EngravingItem.setItem(qty);
    //   } else {
    //     // Update engraving quantity
    //     EngravingItem.updateItem(qty);
    //   }
    // }
  });

}
